const marketData = {
  // العنوان العام للبطاقات
  title: 'كيف يقارن هذا السعر؟',
  districtTitle: 'الصفقات المسجّلة في الحي',
  subtitle: 'مقارنة بالصفقات العقارية المسجّلة فعلياً في {{district}}',
  subtitleNoDistrict: 'مقارنة بالصفقات العقارية المسجّلة فعلياً',

  // شريط النطاق
  band: {
    typical: 'السعر المعتاد',
    perM2: 'ريال / م²',
    halfOfDeals: 'نصف الصفقات بين {{low}} و {{high}}',
    mostDeals: 'معظم الصفقات بين {{low}} و {{high}}',
    deeds_one: 'صفقة واحدة مسجّلة',
    deeds_two: 'صفقتان مسجّلتان',
    deeds_few: '{{count}} صفقات مسجّلة',
    deeds_many: '{{count}} صفقة مسجّلة',
    deeds_other: '{{count}} صفقة مسجّلة',
    window12: 'آخر 12 شهراً',
    window24: 'آخر 24 شهراً',
    period: '{{from}} إلى {{to}}',
    yourPrice: 'سعر هذا الإعلان',
    yourPriceShort: 'هذا الإعلان',
    median: 'الوسيط',
    lowEnd: 'الأدنى',
    highEnd: 'الأعلى',
  },

  // موضع السعر — صياغة محايدة دائماً، بلا أحكام
  position: {
    within: 'ضمن النطاق المعتاد',
    above: 'أعلى من معظم الصفقات المسجّلة',
    below: 'أقل من معظم الصفقات المسجّلة',
    withinNote: 'سعر هذا الإعلان يقع داخل النطاق الذي سجّلته نصف صفقات الحي.',
    aboveNote: 'سعر هذا الإعلان أعلى من النطاق الذي سجّلته نصف صفقات الحي. قد يكون للعقار مزايا لا تظهر في بيانات الصفقات.',
    belowNote: 'سعر هذا الإعلان أقل من النطاق الذي سجّلته نصف صفقات الحي.',
    noArea: 'أضف مساحة العقار لمقارنة سعر المتر.',
  },

  // الإيجارات
  rent: {
    title: 'الإيجار في الحي',
    perYear: 'ريال سنوياً',
    perM2Year: 'ريال / م² سنوياً',
    contracts_one: 'عقد واحد',
    contracts_two: 'عقدان',
    contracts_few: '{{count}} عقود',
    contracts_many: '{{count}} عقد',
    contracts_other: '{{count}} عقد',
    types: {
      apartment: 'شقة',
      studio: 'استديو',
      villa: 'فيلا',
      floor: 'دور',
      duplex: 'دوبلكس',
    },
    yoy: 'مقارنة بالعام السابق',
    freezeNotice: 'تنبيه: يخضع الإيجار في الرياض لقرار تثبيت.',
  },

  // العائد
  yieldCard: {
    title: 'العائد الإيجاري',
    gross: 'العائد الإجمالي',
    note: 'إجمالي قبل المصاريف وضريبة التصرفات العقارية 5%',
    indicative: 'تقديري - العينة محدودة',
  },

  // النشاط
  activity: {
    title: 'نشاط السوق',
    lastFourQuarters: 'صفقة مسجّلة خلال آخر أربعة أرباع',
    rankInCity: 'من بين الأعلى نشاطاً في {{city}}',
  },

  // الصفقات المشابهة
  comps: {
    title: 'صفقات مسجّلة قريبة',
    subtitle: 'هذه صفقات حقيقية مسجّلة في الحي - وليست إعلانات',
    date: 'التاريخ',
    area: 'المساحة',
    price: 'السعر',
    perM2: 'سعر المتر',
    areaUnit: 'م²',
    showAll: 'عرض كل الصفقات',
    showLess: 'عرض أقل',
  },

  // الاتجاه — على مستوى المدينة دائماً
  trend: {
    title: 'اتجاه الأسعار',
    cityLevel: 'على مستوى {{city}}',
    twoYear: 'التغيّر خلال سنتين',
    likeForLike: 'مقارنة بالمثل',
    likeForLikeNote: 'محسوب على عقارات متشابهة في المساحة والحي، حتى لا يبدو تغيّر نوع الصفقات تغيّراً في الأسعار.',
    up: 'ارتفاع',
    down: 'انخفاض',
    flat: 'شبه مستقر',
    noDistrictTrend: 'لا يتوفر اتجاه على مستوى الحي - الرقم أعلاه للمدينة.',
  },

  // الحالات الفارغة
  empty: {
    title: 'بيانات غير كافية',
    notEnoughDeals: 'لا توجد صفقات مسجّلة كافية في هذا الحي لعرض نطاق سعري موثوق.',
    districtUnknown: 'لم نتمكن من مطابقة موقع هذا العقار مع حي في السجل العقاري.',
    noSegment: 'بيانات وزارة العدل تسجّل الفلل والأدوار ضمن «أرض»، لذلك لا يمكن عرض نطاق سعري لهذا النوع.',
    unavailable: 'بيانات السوق غير متاحة حالياً.',
    rentOnly: 'يتوفر لهذا الحي بيانات إيجار فقط.',
  },

  // المصدر والإخلاء
  source: {
    label: 'المصدر',
    sale: 'بيانات الصفقات العقارية المفتوحة - وزارة العدل',
    rent: 'مؤشرات الإيجار - الهيئة العامة للعقار',
    updated: 'حُدّثت في {{date}}',
  },
  disclaimer: 'مؤشر إحصائي استرشادي - ليس تقييماً عقارياً',
  provisional: 'مؤقت',
  provisionalNote: 'منذ الربع الثاني 2025 تُسجَّل صفقات الرياض عبر السجل العقاري، ولا تظهر كاملة في البيانات المفتوحة. اعتبر الأرقام مؤقتة.',
  matchedByCoordinates: 'طوبقت حسب الموقع الجغرافي ({{km}} كم)',

  loading: 'جارٍ تحميل بيانات السوق…',
};

export default marketData;
